// Protege contra crashes de React 19 cuando un traductor del navegador (Google Translate,
// navegadores in-app de WhatsApp/Telegram) muta los nodos de texto del DOM, provocando
// "Failed to execute 'insertBefore'/'removeChild' on 'Node': ... is not a child of this node".
// Patrón recomendado por la comunidad de React: hacer que estas operaciones fallen de forma
// silenciosa cuando el nodo ya no pertenece al padre esperado.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildSafe(child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforeSafe(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
